/**
 * User data type.
 */
export enum UserDataType {
  User = 'USER',
  Pro = 'PRO',
  Admin = 'ADMIN',
  CallAgent = 'CALL_AGENT',
}
